import { Directive } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponseModel } from '../../models/core/api-response.model';
import { KeyValueModel } from '../../models/core/key-value.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { UrlParameterModel } from '../../models/core/url-parameter.model';
import { BaseResource } from './base.resource';

/**
 * Resource base class for lists.
 */
@Directive()
export abstract class BaseListResource extends BaseResource {
    // eslint-disable-next-line @angular-eslint/prefer-inject
    protected constructor(config: ResourceConfig) {
        super(config);
    }

    /**
     * Returns a list of items.
     * @param [description] Text to be searched.
     */
    list(description = '', baseId?: string): Observable<ApiResponseModel<KeyValueModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<KeyValueModel[]>>(
            this.getUrl(this._config.actions.list),
            baseId,
            undefined,
            this._isAbsoluteUrl,
            undefined,
            undefined,
            new UrlParameterModel({ key: 'description', value: description })
        );
    }
}
